module.exports = __webpack_public_path__ + "static/banner-848a5541f8d31a29ebf0a3d9e349751d.png";